<template lang="html">
  <v-hover #default="{ hover }">
    <v-card
      v-bind="$attrs"
      v-ripple="{ center: true }"
      class="tile"
      :elevation="hover ? 4 : 0"
      :color="color"
      @click="!controlKey && emitClick(false)"
      @click.ctrl="emitClick(true)"
      @click.middle="emitClick(true)"
    >
      <v-responsive :aspect-ratio="aspectRatio">
        <slot>
          <v-row
            no-gutters
            align="start"
            justify="start"
            class="fill-height flex-nowrap pa-3"
            :class="column ? 'flex-column' : 'flex-row'"
          >
            <slot name="icon">
              <v-icon
                v-show="icon && icon.length > 0"
                :size="iconSize"
                v-text="iconName"
                class="tile__icon"
              />
            </slot>
            <v-spacer />
            <div class="tile__text custom-text-truncate-2 word-break-break-word mt-2 mt-sm-1" :class="textClass">
              <slot name="text">
                {{ text }}
              </slot>       
            </div>
          </v-row>
        </slot>
      </v-responsive>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  data() {
    return {
      controlKey: false,
    };
  },
  props: {
    // REFACTOR: icon currently doesn't support icons, but requests an image.
    icon: {
      type: String,
      default: '',
    },
    column: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    aspectRatio: {
      type: [String, Number],
      default: 16 / 9,
    },
    color: {
      type: String,
      default: '',
    },
    custom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 56;
        case 'sm':
          return 50;
        case 'md':
          return 50;
        default:
          return 50;
      }
    },
    textClass() {
      return this.$vuetify.breakpoint.xsOnly ? 'body-2 tile__text-font-size-xs' : 'body-1 tile__text-font-size-normal';
    },

    //Icons are stored in the "coredataIcons.js" file
    iconName() {
      let icon = this.icon;
      if (icon && icon.startsWith("mdi")) {
        return icon;
      } else if (this.$vuetify.icons.values[icon] == undefined) {
        return '$cdi-no-icon';
      }
      return '$' + icon;
    },
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Control') {
        this.controlKey = true;
      }
    });
    window.addEventListener('keyup', (e) => {
      if (e.key == 'Control') {
        this.controlKey = false;
      }
    });
    document.addEventListener("visibilitychange", (event) => {
      if (document.visibilityState != "visible") {
        this.controlKey = false;
      }
    }); 
  },
  beforeUnmount() {
    window.removeEventListener("keyup");
    window.removeEventListener("keydown");
    window.removeEventListener("visibilitychange");
  },
  methods: {
    emitClick(newTab = false) {
      if (newTab || this.custom) {
        this.$emit('newTab');
      } else {
        this.$emit('click');
      }
    },
    fromSnakeCaseToKebabCase(snakeCase) {
      var output = snakeCase.replace(/_/g, "-");
      return output;
    },
  }
};
</script>

<style lang="scss" scoped>
.tile {
  position: relative;
  border-radius: 14px;
  min-height: 125px;
  display: flex;
}

.tile__icon {
  flex: 0 0 auto;
}

.tile__text {
  max-width: 100%;
  font-weight: 500;
}

.tile__text-font-size-xs {
  font-size: 0.9rem !important;
}
.tile__text-font-size-normal {
  font-size: 1.0rem !important;
}
</style>
